import { Fragment, useEffect } from 'react'

import { Transition } from '@headlessui/react'
import { useAppDispatch, useAppSelector } from '@/store/hooks'
import Icon from '@/components/atoms/Icon'
import { notificationCreators } from '@/store/ducks/notification'
import { twMerge } from 'tailwind-merge'
import classNames from 'classnames'

export default function Notification() {
	const {
		show,
		options: { title, message },
	} = useAppSelector((state) => state.notification)

	const dispatch = useAppDispatch()

	useEffect(() => {
		let timeout: NodeJS.Timeout

		if (show) {
			timeout = setTimeout(() => dispatch(notificationCreators.hide()), 6000)
		}

		return () => clearTimeout(timeout)
	}, [show, dispatch])

	return (
		<>
			<div
				aria-live='assertive'
				className='fixed inset-0 z-50 flex items-end top-24 px-4 py-6 pointer-events-none sm:p-6 sm:items-start'
			>
				<div className='w-full flex flex-col items-center space-y-4 sm:items-end'>
					<Transition
						show={show}
						as={Fragment}
						enter='transform ease-out duration-300 transition'
						enterFrom='translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2'
						enterTo='translate-y-0 opacity-100 sm:translate-x-0'
						leave='transition ease-in duration-100'
						leaveFrom='opacity-100'
						leaveTo='opacity-0'
					>
						<div
							onClick={() => {
								dispatch(notificationCreators.hide())
							}}
							className='inline-block max-w-max py-3 px-6 cursor-pointer bg-brand-primary hover:bg-brand-primary/80 transition-colors duration-300 shadow-lg rounded-lg pointer-events-auto ring-1 ring-[#000000] ring-opacity-5 overflow-hidden'
						>
							<div>
								<div className='flex items-center'>
									<div className='flex-shrink-0'>
										<Icon name='check-white' width='32' height='32' />
									</div>
									<div className='ml-4 flex-1 gap-1'>
										{title && (
											<p className='text-base font-bold text-white'>
												{title}
											</p>
										)}
										<p
											className={twMerge(
												classNames('text-[17px] text-white font-semibold', {
													'text-[15px] font-medium': !!title,
												})
											)}
										>
											{message}
										</p>
									</div>
								</div>
							</div>
						</div>
					</Transition>
				</div>
			</div>
		</>
	)
}
